// @ts-nocheck

import React, { useCallback, useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";

import { RATypography } from "@/components/customs";
import { PATH_ROUTES } from "@/config/routes";

import s from "./ServiceDropdown.module.css";
import { ButtonV2 } from "@/components/customs/ButtonV2";
import { useRouter } from "next/navigation";

const SERVICE_TYPE = {
	PRIVATE_JET_CHARTER: "private_jet_charter",
	JET_ONE_SUITES: "jet_one_suites",
	AIR_FREIGHT: "air_freight",
};

const SERVICE_TYPE_INDEX = {
	[SERVICE_TYPE.PRIVATE_JET_CHARTER]: 0,
	[SERVICE_TYPE.JET_ONE_SUITES]: 1,
	[SERVICE_TYPE.AIR_FREIGHT]: 2,
};

const SERVICES = {
	[SERVICE_TYPE.PRIVATE_JET_CHARTER]: {
		title: "Private Jet Travel",
		description: "Experience luxury travel, uniquely tailored to your journey.",
		subtitle:
			"Fly with Royal Air and step into a world where luxury meets personal touch. With us, every trip is not just a flight but a carefully designed experience that prioritizes your comfort, style, and individual preferences.",
		link: PATH_ROUTES.PATH_SERVICE_PRIVATE_JET_TRAVEL,
		image: "/images/header/services/Private_Jet_Charter.png",
	},
	[SERVICE_TYPE.JET_ONE_SUITES]: {
		title: "Jet 1 Suites",
		description: "Your aircraft's royal residence with top-tier care.",
		subtitle:
			"Discover a haven for your aircraft at Royal Air. Beyond providing premium hangar space, we ensure dedicated fueling and expert ground staff support, making every departure as smooth as your arrival.",
		link: PATH_ROUTES.PATH_SERVICE_JET_ONE_SUITES,
		image: "/images/header/services/Jet_1_Suites.png",
	},
	[SERVICE_TYPE.AIR_FREIGHT]: {
		title: "Air Freight",
		description: "Royal Air freight elevates cargo with unmatched precision.",
		subtitle:
			"Entrust your cargo with Royal Air freight, where every flight is more than just transportation. We prioritize safety, efficiency, and the utmost care, ensuring your goods are handled with the dedication they deserve.",
		link: PATH_ROUTES.PATH_SERVICE_AIR_FREIGHT,
		image: "/images/header/services/Air_Freight.png",
	},
};

export const ServiceDropdown = React.memo(
	({ open, onUpdateOpenService }: { open: boolean; onUpdateOpenService: (o: boolean) => void }) => {
		const router = useRouter();

		const [selectedType, setSelectedType] = useState(SERVICE_TYPE.PRIVATE_JET_CHARTER);

		const contentInnerRef = useCallback((node: HTMLDivElement) => {
			if (node) {
				const handleClickOutside = (event: MouseEvent) => {
					const btn = document.querySelector("[data-service-dropdown-trigger]");

					if (node && !node.contains(event.target as any) && !btn?.contains(event.target as any)) {
						onUpdateOpenService(false);
					}
				};

				document.addEventListener("mousedown", handleClickOutside);
				return () => {
					document.removeEventListener("mousedown", handleClickOutside);
				};
			}
		}, []);

		return (
			<div
				className={s.container}
				style={{
					background: open ? "rgba(0, 0, 0, 0.2)" : "transparent",
					visibility: open ? "visible" : "hidden",
					opacity: open ? 1 : 0,
				}}
			>
				<div className={s.content}>
					<div
						className={s.content_inner}
						style={{
							transform: open ? "none" : "translateY(-100%)",
						}}
						ref={contentInnerRef}
					>
						<div className={s.service_list}>
							{Object.entries(SERVICES).map(([type, service], index) => (
								<React.Fragment key={type}>
									{index > 0 && <div className={s.divider} />}
									<div
										className={s.service_item}
										style={{
											borderColor: type === selectedType ? "#FFB11A" : "transparent",
										}}
										onClick={() => setSelectedType(type)}
									>
										<div>
											<RATypography variant="gilda1">{service.title}</RATypography>
											<RATypography variant="dm_sans1" top={4}>
												{service.description}
											</RATypography>
										</div>
									</div>
								</React.Fragment>
							))}
							<div
								className={s.service_item_active}
								style={{
									top: SERVICE_TYPE_INDEX[selectedType] * 114 + SERVICE_TYPE_INDEX[selectedType],
								}}
							/>
						</div>
						<div className={s.service_content_wrapper}>
							{Object.entries(SERVICES).map(([type, service], index) => (
								<div
									className={s.service_content}
									key={type}
									style={{
										opacity: type === selectedType ? 1 : 0,
										visibility: type === selectedType ? "visible" : "hidden",
										transition: "all 0.8s",
									}}
									onClick={() => {
										router.push(SERVICES[selectedType]?.link);
										onUpdateOpenService(false);
									}}
								>
									<Image
										src={service.image}
										alt={service.title}
										fill
										sizes="100vw"
										style={{
											objectFit: "cover",
											objectPosition: "center",
										}}
									/>
									<div className={s.service_overlay}>
										<div className={s.service_overlay_content}>
											<div>
												<RATypography variant="gilda2">{service.title}</RATypography>
												<RATypography variant="dm_sans1" top={4} color="#595959">
													{service.subtitle}
												</RATypography>
											</div>
											<ButtonV2 width={100} size="small" color="#222222">
												Details
											</ButtonV2>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		);
	},
);
